export interface CTAConfig {
  label: string;
  targetStatus: string;
  variant: 'primary' | 'success' | 'warning';
}

export interface DockData {
  shipmentNumber?: string | null;
  direction?: string | null;
  trailerLineageUuid?: string | null;
  trailerStatus?: string | null;
}

export function getAvailableCTAs(dock: DockData): CTAConfig | null {
  // Only show CTAs if:
  // 1. There's a shipment
  // 2. There's a trailer with an active lineage
  // 3. The trailer has a current status
  if (!dock.shipmentNumber || !dock.trailerLineageUuid || !dock.trailerStatus) {
    return null;
  }

  const direction = dock.direction; // "inbound" or "outbound"
  const currentStatus = dock.trailerStatus;

  if (direction === "inbound") {
    switch (currentStatus) {
      case "LOADED":
        return { label: "Start Unloading", targetStatus: "UNLOADING STARTED", variant: "primary" };
      case "UNLOADING STARTED":
        return { label: "Complete Unloading", targetStatus: "EMPTY", variant: "success" };
      default:
        return null;
    }
  } else if (direction === "outbound") {
    switch (currentStatus) {
      case "EMPTY":
      case "IN USE": // an empty with its shipment attached
        return { label: "Start Loading", targetStatus: "LOADING STARTED", variant: "primary" };
      case "LOADING STARTED":
        return { label: "Complete Loading", targetStatus: "LOADED", variant: "success" };
      default:
        return null;
    }
  }

  return null;
}